import React from "react";
import Card from "react-bootstrap/Card";

function AtlantisCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            <span className="purple">Atlantis</span>{" "}
             si sta affermando come uno dei server Minecraft italiani più interessanti, 
             grazie a nuove <span className="purple">meccaniche dinamiche</span> dedicate alla modalità{" "}
            <span className="purple">Roleplay</span>.
            <br />
            <br />
            L'esperienza si svolge in un arcipelago ispirato alle{" "}
            <span className="purple">Isole Canarie{" "}</span>
            composto da diverse zone distinte:
            <br />
            <br />
            L'isola maggiore, che ospita la metropoli di{" "}<span className="purple">Liberty Bay</span>, collegata a un isolotto adibito ai Magazzini.{" "}
            Poi c'è l'isola del{" "}<span className="purple">Penitenziario</span>.
            Infine, la grande <span className="purple">isola vulcanica</span>, dedicata alle attività di raccolta risorse come pesca, estrazione mineraria e agricoltura.
            <br />
            <br />
            <span className="joystick" role="img" aria-label="joystick">
              🎮
            </span>
            {" "} Accessibile all'IP: <span className="purple">ita.coralmc.it</span>
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AtlantisCard;
